import React, { useState, useCallback } from "react";
import Cropper from "react-easy-crop";
import getCroppedImg from "./getCroppedImg";
import "./imageCropper.css";
import useModalDismiss from "../useModalDismiss";

const ImageCropper = ({
	imageSrc,
	aspect = 4 / 3,
	cropShape = "rect",
	title,
	cancelLabel = "Cancel",
	saveLabel = "Save",
	savingLabel = "Saving...",
	zoomLabel = "Zoom",
	onCancel,
	onSave,
}) => {
	const [crop, setCrop] = useState({ x: 0, y: 0 });
	const [zoom, setZoom] = useState(1);
	const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);
	const [processing, setProcessing] = useState(false);

	useModalDismiss(onCancel, { enabled: !processing });

	const onCropComplete = useCallback((_, areaPixels) => {
		setCroppedAreaPixels(areaPixels);
	}, []);

	const handleSave = async () => {
		if (!croppedAreaPixels || processing) return;
		setProcessing(true);
		try {
			const blob = await getCroppedImg(imageSrc, croppedAreaPixels);
			await onSave(blob);
		} finally {
			setProcessing(false);
		}
	};

	return (
		<div className="sf-crop-overlay">
			<div className="sf-crop-modal">
				{title && <div className="sf-crop-title">{title}</div>}

				<div className="sf-crop-stage">
					<Cropper
						image={imageSrc}
						crop={crop}
						zoom={zoom}
						aspect={aspect}
						cropShape={cropShape}
						onCropChange={setCrop}
						onCropComplete={onCropComplete}
						onZoomChange={setZoom}
					/>
				</div>

				<div className="sf-crop-controls">
					<span className="sf-crop-zoom-label">{zoomLabel}</span>
					<input
						type="range"
						min={1}
						max={3}
						step={0.01}
						value={zoom}
						onChange={(e) => setZoom(Number(e.target.value))}
					/>
				</div>

				<div className="sf-crop-actions">
					<button type="button" className="btn ghost" onClick={onCancel} disabled={processing}>
						{cancelLabel}
					</button>
					<button type="button" className="btn" onClick={handleSave} disabled={processing || !croppedAreaPixels}>
						{processing ? savingLabel : saveLabel}
					</button>
				</div>
			</div>
		</div>
	);
};

export default ImageCropper;
